import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";
import LockedLoadSerializer from "../serializers/LockedLoadSerializer";
import LockedUserSerializer from "../serializers/LockedUserSerializer";

export default class ShotClockRepository {
  SHOT_CLOCK_BASE = "/locking";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async lockLoad(instance, params, orderId) {
    const token = await getToken(instance);
    const path = `${this.SHOT_CLOCK_BASE}/movements/lock?${params}`;
    this.headers.Authorization = `Bearer ${token}`;
    this.headers.Component = "Shot Clock";
    this.headers.Action = `Locked load ${orderId}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers
    });

    return Promise.resolve(req);
  }

  async unlockLoad(instance, params) {
    const token = await getToken(instance);
    const path = `${this.SHOT_CLOCK_BASE}/movements/unlock?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers
    });

    return Promise.resolve(req);
  }

  async getLockedLoads(instance) {
    const token = await getToken(instance);
    const path = `${this.SHOT_CLOCK_BASE}/lockedmovements`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.lockMovements) {
      return Promise.resolve(req.lockMovements.map(user => (
        LockedLoadSerializer.deSerialize(user)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async getPendingLocks(instance, params) {
    const token = await getToken(instance);
    const path = `${this.SHOT_CLOCK_BASE}/pendinglocks?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.pendingLockUser) {
      return Promise.resolve(req.pendingLockUser.map(user => (
        LockedUserSerializer.deSerialize(user)
      )));
    } else {
      return Promise.resolve([]);
    }
  }

  async addPendingLock(instance, params) {
    const token = await getToken(instance);
    const path = `${this.SHOT_CLOCK_BASE}/pendinglocks?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "POST",
      headers: this.headers
    });

    return Promise.resolve({});
  }

  async removePendingLock(instance, params) {
    const token = await getToken(instance);
    const path = `${this.SHOT_CLOCK_BASE}/pendinglocks?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    await request(path, {
      method: "DELETE",
      headers: this.headers
    });

    return Promise.resolve({});
  }
}